module.exports = __webpack_public_path__ + "static/img/12.aecd5b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/12.png
// module id = 5/XB
// module chunks = 0